import * as React from 'react'

import './styles.scss'
import ToggleSwitch from './ToggleSwitch'
import { lang } from 'utils/helpers'

const TitleCard = ({ checked, setChecked }) => (
  <div className='title-card'>
    <div className='title-section'>
      <p className='title'>
        {lang('dashboard_notifications')}
      </p>
      <p className='subtitle'>
        {lang('notifications_view_title_card_subtitle')}
      </p>
    </div>
    <div className='options-section'>
      <div className='switch-container'>
        <ToggleSwitch
          switchWidth={56}
          switchHeight={28}
          switchColor='#E87721'
          switchHandleColor='#fff'
          checked={!!checked}
          switchTitle={lang('dashboard_notifications-activated')}
          onChange={({ value }) => setChecked({ fieldName: 'isActive', fieldValue: value })}
        />
      </div>
    </div>
  </div>
)

export default TitleCard
